import { useEffect, useRef, useState } from 'react';
import { Button, Group, PasswordInput } from '@mantine/core';
import { IUser, IUserUpdate, updateUser } from '../../../libraries/user';
import ModalComponent from '../../components/modal';
import { Language } from '../../languages/languageHandler';
import { StatusType } from '../../../libraries/zps';
import { useStatusOperDialog } from '../../context/status-oper-dialog';
import './styles.scss';

const UpdateUserConfirmation: React.FC<{
  userData: Partial<IUser>;
  lang: Language;
  toggleModal: () => void;
  openModal: boolean;
  onSubmit: (data?: any) => void;
}> = ({ userData, lang, toggleModal, openModal }) => {
  const controller = useRef(new AbortController()).current;

  const [currentPassword, setCurrentPassword] = useState<string>('');
  const { handleApiError, showStatusOperDialog } = useStatusOperDialog();

  useEffect(() => {
    if (!openModal) {
      setCurrentPassword('');
    }
  }, [openModal]);

  const submitForm = async (formValues: any) => {
    const request: IUserUpdate = {
      user: {
        ...userData,
        ...formValues
      },
      currentPassword
    };

    updateUser(request, controller)
      .then(response => {
        const status = response.data.statusOper;

        if (!status || status.code !== 0) {
          showStatusOperDialog({
            type: StatusType.ERROR,
            message: lang.EDIT_USER_ALERT_UPDATE_ERROR,
            statusOper: status
          });
          return;
        }

        showStatusOperDialog({
          type: StatusType.INFO,
          message: lang.EDIT_USER_ALERT_UPDATE_SUCCESS,
          statusOper: status
        });

        toggleModal();
      })
      .catch(err => {
        handleApiError(err, lang.EDIT_USER_ALERT_UPDATE_ERROR);
      });
  };

  const handleClose = () => {
    setCurrentPassword('');
    toggleModal();
  };

  return (
    <>
      {/* Modal for updating user */}
      <ModalComponent
        show={openModal}
        handleClick={handleClose}
        title={lang.USER_CONFIRM_PASSWORD}
        content={
          <form
            onSubmit={e => {
              e.preventDefault();
              submitForm({});
            }}
          >
            <Group classNames={{ root: 'update-confirmation' }}>
              <PasswordInput
                label={lang.USER_CONFIRM_CURRENT_PASSWORD}
                value={currentPassword}
                onChange={event => setCurrentPassword(event.target.value)}
                type="password"
              />
            </Group>
            <Group>
              <Button type="submit" color="#016273" radius="md">
                {lang.GLOBAL_SAVE_BUTTON}
              </Button>
              <Button color="#016273" radius="md" onClick={handleClose}>
                {lang.GLOBAL_CANCEL}
              </Button>
            </Group>
          </form>
        }
      />
    </>
  );
};

export default UpdateUserConfirmation;
